import { IRenderFn } from "@/utils/types";
import { ICellEvents, ICellProps, renderCell } from "./Cell.component";
import styles from "./UrlCell.component.module.scss";

export interface IUrlCellProps extends ICellProps {
  url: string;
  download?: boolean;
  iconSrc?: string;
}

export const renderUrlCell: IRenderFn<IUrlCellProps, ICellEvents> = (
  h,
  { props, children, listeners, data },
) =>
  renderCell(h, {
    props,
    children: (
      <a
        href={props.url}
        target="_blank"
        onClick={(ev) => {
          ev.stopPropagation();
        }}
        download={props.download}
        rel="noopener noreferrer"
        data-testid={`download-${props.dataTestId}`}
      >
        {props.download ? (
          <img src={props.iconSrc} alt="Download" class={styles.downloadIcon} />
        ) : (
          children
        )}
      </a>
    ),
    listeners,
    data,
  });
